var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"successPage"},[_c('div',{staticClass:"successPage_box"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._t("content")],2)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imgbox"},[_c('img',{attrs:{"src":require("../../../../../assets/img/success.png"),"alt":""}})])
}]

export { render, staticRenderFns }